import { createContext, ReactNode, useState } from 'react'
import { userEmailSessionStorageKey } from '../app/storageKeys'

type UserEmailContextType = [string, (newEmail: string) => void]

const loadUserEmailFromSessionStorage = () => {
  return sessionStorage.getItem(userEmailSessionStorageKey) ?? ''
}

const saveuserEmailToSessionStorage = (userEmail: string) => {
  sessionStorage.setItem(userEmailSessionStorageKey, userEmail)
}

export const UserEmailContext = createContext<UserEmailContextType>([
  '',
  (_: string) => {},
])

interface UserEmailProviderProps {
  children: ReactNode
}

export const UserEmailProvider = ({ children }: UserEmailProviderProps) => {
  const [userEmail, setUserEmail] = useState<string>(
    loadUserEmailFromSessionStorage(),
  )

  const setUserEmailStateAndSessionStorage = (newEmail: string) => {
    saveuserEmailToSessionStorage(newEmail)
    setUserEmail(newEmail)
  }

  const value: UserEmailContextType = [
    userEmail,
    setUserEmailStateAndSessionStorage,
  ]
  return (
    <UserEmailContext.Provider value={value}>
      {children}
    </UserEmailContext.Provider>
  )
}
